import React, { createContext, useContext, useState, ReactNode } from 'react';
import { useProjects } from '@/hooks/useProjects';
import { Project } from '@/services/supabase/types';

interface ProjectSelectionContextType {
  projects: Project[];
  projectsLoading: boolean;
  selectedProject: Project | null;
  selectedProjectId: string | null;
  setSelectedProjectId: (projectId: string | null) => void;
}

const ProjectSelectionContext = createContext<ProjectSelectionContextType | undefined>(undefined);

interface ProjectSelectionProviderProps {
  children: ReactNode;
}

export const ProjectSelectionProvider: React.FC<ProjectSelectionProviderProps> = ({ children }) => {
  const { projects, loading: projectsLoading } = useProjects();
  const [selectedProjectId, setSelectedProjectId] = useState<string | null>(null);
  
  // Find the selected project object
  const selectedProject = selectedProjectId && selectedProjectId !== "none"
    ? projects.find(p => p.id === selectedProjectId) 
    : null;
  
  const handleProjectChange = (projectId: string | null) => {
    setSelectedProjectId(projectId);
  };
  
  const value = {
    projects,
    projectsLoading,
    selectedProject,
    selectedProjectId,
    setSelectedProjectId: handleProjectChange
  };

  return (
    <ProjectSelectionContext.Provider value={value}>
      {children}
    </ProjectSelectionContext.Provider>
  );
};

export const useProjectSelectionContext = () => {
  const context = useContext(ProjectSelectionContext);
  if (context === undefined) {
    console.error('ERROR: useProjectSelectionContext called outside of ProjectSelectionProvider');
    throw new Error('useProjectSelectionContext must be used within a ProjectSelectionProvider');
  }
  return context;
};